import script from "./EditorHtml.vue?vue&type=script&setup=true&lang=js"
export * from "./EditorHtml.vue?vue&type=script&setup=true&lang=js"

import "./EditorHtml.vue?vue&type=style&index=0&id=060c0e24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-060c0e24"]])

export default __exports__